import { createReducer, on } from '@ngrx/store';
import { FlattenGraphQl } from 'src/app/utility';
import { MailingAddress, ShopifyError } from '../../models';

import * as actions from '../actions/addresses.action';
import * as utility from '../../../utility';
import { cleanAddressId } from '../../services';

export interface AddressesState {
  entities: { [id: string]: MailingAddress };
  loading: boolean;
  loaded: boolean;
  updatet: boolean;
  errors: ShopifyError[];
  updatingEntity?: string;
  pageInfo?: {
    cursor: string;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export const initialState: AddressesState = {
  loading: false,
  loaded: false,
  updatet: false,
  errors: [],
  entities: {},
  pageInfo: {
    cursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
  },
};

export const addressesReducer = createReducer(
  initialState,
  on(actions.LoadAddresses, (state: AddressesState) => {
    return {
      ...state,
      loading: true,
      loaded: false,
      updatet: false,
      errors: [],
      updatingEntity: undefined,
    };
  }),
  on(actions.LoadAddressesSuccess, (state: AddressesState, { addresses }) => {
    const addressesResult = addresses?.edges.map((e: { node: any }) => FlattenGraphQl(e.node));
    addressesResult.map((a: any) => (a.cleanId = cleanAddressId(a.id)));
    // console.log(addressesResult);
    const entities = utility.ToEntities(addressesResult, 'cleanId', state.entities);

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
      pageInfo: {
        cursor: addresses?.edges[addresses?.edges.length - 1]?.cursor || state?.pageInfo?.cursor,
        hasNextPage: addresses?.pageInfo.hasNextPage,
        hasPreviousPage: addresses?.pageInfo.hasPreviousPage,
      },
      errors: [],
      updatingEntity: undefined,
    };
  }),
  on(actions.LoadAddressesFail, actions.UpdateAddressFail, actions.AddAddressFail, (state: AddressesState, { errors }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      errors,
    };
  }),
  on(actions.AddAddress, (state: AddressesState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.AddAddressSuccess, (state: AddressesState, { address }) => {
    address = { ...address, cleanId: cleanAddressId(address.id) };
    const entities = { ...state.entities, [address.cleanId]: address };

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
      errors: [],
      updatingEntity: undefined,
    };
  }),
  on(actions.UpdateAddress, (state: AddressesState, { id }) => {
    const cleanId = cleanAddressId(id);
    return {
      ...state,
      updatingEntity: cleanId,
      updatet: false,
      loading: true,
      loaded: false,
    };
  }),
  on(actions.UpdateAddressSuccess, (state: AddressesState, { address, id }) => {
    address = { ...address, cleanId: cleanAddressId(address.id) };
    const entities = { ...state.entities, [address.cleanId]: address };

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
      updatet: true,
      errors: [],
      updatingEntity: undefined,
    };
  }),
  on(actions.DeleteAddress, (state: AddressesState, { id }) => {
    return {
      ...state,
      updatingEntity: id,
    };
  }),
  on(actions.DeleteAddressSuccess, (state: AddressesState, { id }) => {
    const cleanId = cleanAddressId(id);
    const entities = { ...state.entities };
    const deletetAddress = state.entities[cleanId];

    if (deletetAddress) {
      delete entities[cleanId];
    }

    return {
      ...state,
      entities,
      updatingEntity: undefined,
    };
  }),
  on(actions.ResetAddressLoadingStates, (state: AddressesState) => {
    return {
      ...state,
      loading: false,
      updatet: false,
      errors: [],
      updatingEntity: undefined,
    };
  }),
  on(actions.ResetAddresses, (state: AddressesState) => {
    return {
      ...initialState,
    };
  })
);

export const getAddressesLoading = (state: AddressesState) => state.loading;
export const getAddressesLoaded = (state: AddressesState) => state.loaded;
export const getAddressesErrors = (state: AddressesState) => state.errors;

export const getAddresses = (state: AddressesState) => state.entities;
export const getAddressesPageInfo = (state: AddressesState) => state.pageInfo;

export const getAddressesLoadingId = (state: AddressesState) => state.updatingEntity;
export const getAddressesUpdatet = (state: AddressesState) => state.updatet;
// export const getAddressesLoaded = (state: AddressesState) => state.loaded;
// export const getAddressesErrors = (state: AddressesState) => state.errors;
